<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nkpgx6/tc-custom/cover.jpg?1684255621274?1706297160659" alt="This image is the cover for the book International Petroleum Accounting"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">International Petroleum Accounting
      </h1>
      <p class="bookDescription body article font2">
        <p>This book uniquely presents a comprehensive guide to both U.S. accounting standards and the International Accounting Standards Board (IFRS). The 2nd edition focuses on accounting standards and guidance issued by the IFRS, the U.S. Financial Accounting Standards Board, and the U.S. Securities Exchange Commission.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charlotte J. Wright
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      PennWell
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d378ad1e